import React from 'react'
import { Footer } from '../components/Footer'

export const Home = () => {
  return (
    <>
    <div className="p-6 bg-slate-300"></div>

    
    <div className='hero'>
        

    <div className='content'>
    <h1 className='title'>DVD SHOP</h1>
    </div>
    </div>


    <section className="flex flex-row flex-wrap gap-4 mt-20 mx-auto justify-center p-10">

    <h1 className='mb-4 text-3xl'>DVD SHOP !</h1>

    <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum illum, deleniti corrupti, beatae facilis iusto eos vero placeat ullam necessitatibus amet unde quis quos similique earum quasi sequi excepturi ab consequatur dolorem? Eum debitis minus blanditiis enim sapiente hic earum? Iure cum modi nesciunt, excepturi quam aperiam neque minus unde numquam cupiditate aut consequuntur dolorem dolore quidem! Minus, molestiae maxime ipsa exercitationem beatae tenetur illum cum voluptates delectus odit ad dicta explicabo placeat asperiores mollitia? Saepe minima dolor iusto. Ducimus eligendi expedita maxime? Dignissimos repellendus, quos tempore, corrupti repellat culpa minima laudantium, modi expedita debitis voluptatum veniam eius exercitationem dicta dolores similique id provident perferendis cupiditate mollitia tenetur ex at quisquam facere. Cum sunt impedit iste, labore quod cupiditate ut ab aspernatur veniam mollitia voluptas enim error fugit sapiente quidem tempora. Expedita rem ducimus veritatis fuga animi nam pariatur illo libero voluptatum porro. Explicabo neque, consequuntur perferendis mollitia velit deleniti praesentium sapiente asperiores aut ullam, tempora nesciunt. Nisi exercitationem ipsum enim reprehenderit, neque repudiandae beatae, voluptate cumque ipsa minus vel, perspiciatis voluptatem quia incidunt? Tempora, praesentium non eveniet inventore debitis magni rem nihil aspernatur libero quas quaerat aut, nesciunt quisquam at voluptatibus. Quo error vero deleniti voluptate, porro quaerat minima.</p>

      </section>

      <Footer />
        </>
  )
}
